import { set } from "date-fns";
import React, {
  createContext,
  useMemo,
  useState,
} from "react";
import { AddAccessListsDialog } from "../Components/AddAccessListsDialog/AddAccessListsDialog";

export const PoolsPageContext = createContext();

export const PoolsPageContextProvider = (props) => {
  const [tableGroup, setTableGroup] = useState({});
  const [detailGroup, setDetailGroup] = useState({});

  const [treeOpen, setTreeOpen] = React.useState(false);
  const [siteSelected, setSiteSelected] = useState(false);
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [groupSelectedName, setGroupSelectedName] =
    useState("");
  const [openAddConfigModal, setOpenAddConfigModal] =
    useState(false);

  const [poolDataToEdit, setPoolDataToEdit] =
    React.useState({});

  const [editModeOn, setEditModeOn] = React.useState(false);
  const [deletionDialogMessage, setDeletionDialogMessage] =
    useState("");
  const [deletionDialogOpen, setDeletionDialogOpen] =
    useState(false);
  const [
    deleteDialogHeaderMessage,
    setDeleteDialogHeaderMessage,
  ] = useState("");
  // whiteLists state management

  const [accessLists, setAccessLists] = useState([]);
  const [accessListsCopy, setAccessListsCopy] = useState(
    []
  );
  const [editWhiteListsOn, setEditWhiteListsOn] =
    useState(false);

  const [deletionOrEditIndex, setDeletionOrEditIndex] =
    useState(null);

  const [deletionHeaderMessage, setDeletionHeaderMessage] =
    useState("");
  const [
    deletionSubHeaderMessage,
    setDeletionSubHeaderMessage,
  ] = useState("");
  const [
    openWhiteListsDeletionDialog,
    setOpenWhiteListsDeletionDialog,
  ] = useState(false);

  const [whiteListToDelete, setWhiteListToDelete] =
    useState(null);

  const [openAccessListsDialog, setOpenAccessListsDialog] =
    useState(false);
  const [accessListEditIndex, setAccessListEditIndex] =
    useState(null);
  const [searchValue, setSearchValue] = useState("");

  const contextValue = useMemo(() => {
    return {
      tableGroup,
      setTableGroup,
      detailGroup,
      setDetailGroup,
      treeOpen,
      setTreeOpen,
      siteSelected,
      setSiteSelected,
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
      openAddConfigModal,
      setOpenAddConfigModal,
      poolDataToEdit,
      setPoolDataToEdit,
      editModeOn,
      setEditModeOn,
      deleteDialogHeaderMessage,
      setDeleteDialogHeaderMessage,
      deletionDialogMessage,
      setDeletionDialogMessage,
      deletionDialogOpen,
      setDeletionDialogOpen,
      accessLists,
      setAccessLists,
      accessListsCopy,
      setAccessListsCopy,
      editWhiteListsOn,
      setEditWhiteListsOn,
      deletionHeaderMessage,
      setDeletionHeaderMessage,
      deletionSubHeaderMessage,
      setDeletionSubHeaderMessage,
      openWhiteListsDeletionDialog,
      setOpenWhiteListsDeletionDialog,
      whiteListToDelete,
      setWhiteListToDelete,
      openAccessListsDialog,
      setOpenAccessListsDialog,
      deletionOrEditIndex,
      setDeletionOrEditIndex,
      accessListEditIndex,
      setAccessListEditIndex,
      searchValue,
      setSearchValue,
    };
  }, [
    tableGroup,
    detailGroup,
    treeOpen,
    siteSelected,
    siteSelectedName,
    groupSelectedName,
    openAddConfigModal,

    poolDataToEdit,
    setPoolDataToEdit,

    setTableGroup,
    setDetailGroup,
    setTreeOpen,
    setSiteSelected,
    setSiteSelectedName,
    setGroupSelectedName,
    setOpenAddConfigModal,
    editModeOn,
    setEditModeOn,
    deleteDialogHeaderMessage,
    setDeleteDialogHeaderMessage,
    deletionDialogMessage,
    setDeletionDialogMessage,
    deletionDialogOpen,
    setDeletionDialogOpen,
    accessLists,
    setAccessLists,
    accessListsCopy,
    setAccessListsCopy,
    editWhiteListsOn,
    setEditWhiteListsOn,
    deletionHeaderMessage,
    setDeletionHeaderMessage,
    deletionSubHeaderMessage,
    setDeletionSubHeaderMessage,
    openWhiteListsDeletionDialog,
    setOpenWhiteListsDeletionDialog,
    whiteListToDelete,
    setWhiteListToDelete,
    openAccessListsDialog,
    setOpenAccessListsDialog,
    deletionOrEditIndex,
    setDeletionOrEditIndex,
    accessListEditIndex,
    setAccessListEditIndex,
    searchValue,
    setSearchValue,
  ]);

  return (
    <PoolsPageContext.Provider value={contextValue}>
      {props.children}
    </PoolsPageContext.Provider>
  );
};
